import { React } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import HeaderNav from "../../Components/Header/Header";
import ProductionJobCards from "./ProductionJobCards/productionJobCards";
import ProductionDetailsData from "./ProductionDetails/productionDetails";
import ProductionDetData from "./ProductionJobCards/productionJobCardDetails";
import JumboReelsData from "./JumboReels/jumboReels";
import ExportJumboReels from "./JumboReels/exportJumboReels";
import ExportJumboReelsPdf from "./JumboReels/exportJumboReelsPdf";
import AddNewJumboReel from "./JumboReels/addNewJumboReel";
import EditJumboReel from "./JumboReels/editJumboReel";
import ViewJumboReel from "./JumboReels/viewJumboReel";
import PrintParentReelPdf from "../Print/printParentReel";
import PrintJobCardPdf from "../Print/printJobCardsPdf.jsx";
import ExportProductionDetails from "./ProductionDetails/exportProductionDetails";
import ExportProductionDetailsPdf from "../Exports/exportProductionDetailsPdf";
import PrintJobCardDetails from "../Print/printJobCardDetails";
import ExportRecordsAnimation from "../Exports/exportRecordsAnimationScreen";
import SheetJobCardDetailData from "../DeckleMatching/JobCards/SheetJobCardDetails";
import PrintSheetJobCardDetails from "../Print/printSheetJobCardDetails";
import PrintDuplexJobCardDetails from "../Print/printDuplexJobCardDetails";
import ProductionJobcardDetailsMultistage from "./ProductionJobCards/productionJobCardDetailsMultistage.jsx";
import MultiStageJobCardDetails from "../ProductionPlanning/ProductionJobCards/multiStageProdJobCardDetails.jsx";
import ProductionDetails from "../ProductionPlanning/ProductionDetails/multistageProductionDetails.jsx";
import PrintMultiStageJobCardDetails from "../Print/printMultiStageJobCardDetails.jsx";
const { Content } = Layout;

const ProductionPlanning = (props) => {
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const listItems =[];
     if(userDetails.roles.production.job_cards.edit || userDetails.roles.production.job_cards.view)
     {
      listItems.push(
        {
          icon: "jobcard-icon",
          label: "Job Cards",
          link: "Production-job-cards",
        }
      );
     }
     if(userDetails.roles.production.jumbo_reels.edit || userDetails.roles.production.jumbo_reels.view)
     {
      listItems.push(
        {
          icon: "tissue-role",
          label: "Jumbo Rolls",
          link: "jumbo-reel-records",
        }
       
      );
     }
     if(userDetails.roles.production.prod_details.edit || userDetails.roles.production.prod_details.view)
     {
      listItems.push(
        {
          icon: "production-icon",
          label: "Production Details",
          link: "production-detail",
        }
      );
     }
  return (
    <Layout>
      <HeaderNav />
      <Layout>
        <Sidebar headerName="Production Planning" listItems={listItems} />
        <Layout>
          <Content>
            <Routes>
              <Route path="/production-job-cards" element={<ProductionJobCards />} />
              <Route path="/production-job-cards/job-card-details" element={<ProductionDetData />} />
              <Route path="/production-job-cards/multi-stage-job-card-details" element={<MultiStageJobCardDetails />} />
              <Route path="/production-job-cards/job-card-details/print-pdf" element={<PrintJobCardDetails />} />
              <Route path="/production-job-cards/job-card-details/print-parent-reel/pdf" element={<PrintParentReelPdf />} />
              <Route path="/production-job-cards/multi-stage-job-card-details/print-parent-reel/pdf" element={<PrintParentReelPdf />} />
              <Route path="/production-job-cards/job-card-details/print-job-card/pdf" element={<PrintJobCardPdf />} />
              {/* <Route path="/production-detail" element={<ProductionDetailsData />} /> */}
              <Route path="/production-detail" element={<ProductionDetails />} />
              <Route path="/production-detail/export-production-details" element={<ExportProductionDetails />} />
              <Route path="/production-detail/export-production-details/pdf" element={<ExportProductionDetailsPdf />} />
              <Route path="/production-detail/preparing-export-production-details" element={<ExportRecordsAnimation />} />
              <Route path="/jumbo-reel-records" element={<JumboReelsData />} />
              <Route path="/jumbo-reel-records/add-new-jumbo-reel" element={<AddNewJumboReel/>}/>
              <Route path="/jumbo-reel-records/edit-jumbo-reel" element={<EditJumboReel/>}/>
              <Route path="/jumbo-reel-records/view-jumbo-reel" element={<ViewJumboReel/>}/>
              <Route path="/jumbo-reel-records/export" element={<ExportJumboReels/>} />
              <Route path="/jumbo-reel-records/exportPdf" element={<ExportJumboReelsPdf/>} />
              <Route path="/production-job-cards/sheet-job-card-details" element={<SheetJobCardDetailData />} />
              <Route path="/production-job-cards/sheet-job-card-details/print" element={<PrintSheetJobCardDetails/>}/>
              <Route path="/production-job-cards/sheet-job-card-details/duplex-print" element={<PrintDuplexJobCardDetails />} />
              <Route path="/production-job-cards/job-card-details-multistage" element={<ProductionJobcardDetailsMultistage />} />
              <Route path="/production-job-cards/multi-stage-job-card-details/print" element={<PrintMultiStageJobCardDetails/>}/>

            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ProductionPlanning;
